import RoutePlans  from '@/components/routeplan/routeplan-list';
import RoutePlanCreate from '@/components/routeplan/routeplan-create';
import RoutePlanView  from '@/components/routeplan/routeplan-view';
import RoutePlanPrint from '@/components/routeplan/routeplan-print';
import RoutePlanUpdate  from '@/components/routeplan/routeplan-update';

const routes = [
    {
        path: '/routeplans',
        name: 'routeplans',
        component: RoutePlans,
        meta: {
            breadcrumb: [
                {
                    text: 'Home',
                    to: { name: 'home' }
                },
                { text: 'Route Plans' }
            ],
			requiresAuth: true
        }
    },
	{
        path: '/routeplans/create',
        name: 'routeplancreate',
        component: RoutePlanCreate,
        meta: {
            breadcrumb: [
                {
                    text: 'Home',
                    to: { name: 'home' }
                },
				{
					text: 'Route Plans',
					to: { name: 'routeplans' }
				},
                { text: 'Create Route' }
            ],
			requiresAuth: true
        }
	},
	{
        path: '/routeplans/:id',
        name: 'routeplanview',
        component: RoutePlanView,
        meta: {
            breadcrumb: [
                {
                    text: 'Home',
                    to: { name: 'home' }
				},
				{
					text: 'Route Plans',
					to: { name: 'routeplans' }
				},
                { text: 'View Route' }
            ],
			requiresAuth: true
        }
    },
	{
        path: '/routeplans/:id/print',
        name: 'routeplanprint',
        component: RoutePlanPrint,
        meta: {
            breadcrumb: [
                {
                    text: 'Home',
                    to: { name: 'home' }
				},
				{
					text: 'Route Plans',
					to: { name: 'routeplans' }
				},
                { text: 'Print Route' }
            ],
			requiresAuth: true
        }
    },
	{
        path: '/routeplans/:id/update',
        name: 'routeplanupdate',
        component: RoutePlanUpdate,
        meta: {
            breadcrumb: [
                {
                    text: 'Home',
                    to: { name: 'home' }
				},
				{
					text: 'Route Plans',
					to: { name: 'routeplans' }
				},
                { text: 'Edit Route' }
            ],
			requiresAuth: true
        }
    },
	{
        path: '/routeplans/:id/view',
        name: 'routeplanview',
        component: RoutePlanView,
        meta: {
            breadcrumb: [
                {
                    text: 'Home',
                    to: { name: 'home' }
				},
				{
					text: 'Route Plans',
					to: { name: 'routeplans' }
				},
                { text: 'View Route' }
            ],
			requiresAuth: true
        }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/components/routeplan/routes/index.js